import { SvgIconProps } from '@material-ui/core';
import { FC, forwardRef } from 'react';
import { ReactComponent as PentagonEnergyIconSvg } from './pentagon-energy.svg';
import { ReactComponent as EnergyIconSvg } from './energy.svg';
import { ReactComponent as PentagonLogoIconSvg } from './pentagon-logo.svg';
import { ReactComponent as PentagonTechnologyDeploymentIconSvg } from './pentagon-technology-deployment.svg';
import { ReactComponent as TechnologyDeploymentIconSvg } from './technology-deployment.svg';
import { ReactComponent as PentagonConstructionIconSvg } from './pentagon-construction.svg';
import { ReactComponent as ConstructionIconSvg } from './construction.svg';
import { ReactComponent as PentagonWirelessIconSvg } from './pentagon-wireless.svg';
import { ReactComponent as WirelessIconSvg } from './wireless.svg';
import { ReactComponent as EngineeringIconSvg } from './engineering.svg';
import { ReactComponent as PentagonEngineeringIconSvg } from './pentagon-engineering.svg';
import { ReactComponent as CloseIconSvg } from './close-icon.svg';
import { ReactComponent as MainLogoIconSvg } from './main-logo.svg';
import { ReactComponent as Logo1IconSvg } from './logo1.svg';
import { ReactComponent as Logo2IconSvg } from './logo2.svg';
import { ReactComponent as Logo3IconSvg } from './logo3.svg';
import { ReactComponent as Logo4IconSvg } from './logo4.svg';
import { ReactComponent as Logo5IconSvg } from './logo5.svg';
import { ReactComponent as Logo6IconSvg } from './logo6.svg';
import { ReactComponent as Logo7IconSvg } from './logo7.svg';
import { ReactComponent as Logo8IconSvg } from './logo8.svg';
import { ReactComponent as Logo9IconSvg } from './logo9.svg';
import { ReactComponent as Logo10IconSvg } from './logo10.svg';
import { ReactComponent as Logo11IconSvg } from './logo11.svg';
import { ReactComponent as Logo12IconSvg } from './logo12.svg';
import { ReactComponent as LogoOnHoverIconSvg } from './logoOnHover.svg';

export const PentagonEnergyIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <PentagonEnergyIconSvg ref={ref} {...props} />);
export const EnergyIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <EnergyIconSvg ref={ref} {...props} />);
export const PentagonLogoIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <PentagonLogoIconSvg ref={ref} {...props} />);
export const PentagonTechnologyDeploymentIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <PentagonTechnologyDeploymentIconSvg ref={ref} {...props} />
));
export const TechnologyDeploymentIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <TechnologyDeploymentIconSvg ref={ref} {...props} />
));
export const PentagonConstructionIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <PentagonConstructionIconSvg ref={ref} {...props} />
));
export const ConstructionIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <ConstructionIconSvg ref={ref} {...props} />);
export const PentagonWirelessIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <PentagonWirelessIconSvg ref={ref} {...props} />
));
export const WirelessIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <WirelessIconSvg ref={ref} {...props} />);
export const EngineeringIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <EngineeringIconSvg ref={ref} {...props} />);
export const PentagonEngineeringIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <PentagonEngineeringIconSvg ref={ref} {...props} />
));
export const CloseIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <CloseIconSvg ref={ref} {...props} />);
export const MainLogoIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <MainLogoIconSvg ref={ref} {...props} />);
export const Logo1Icon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <Logo1IconSvg ref={ref} {...props} />);
export const Logo2Icon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <Logo2IconSvg ref={ref} {...props} />);
export const Logo3Icon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <Logo3IconSvg ref={ref} {...props} />);
export const Logo4Icon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <Logo4IconSvg ref={ref} {...props} />);
export const Logo5Icon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <Logo5IconSvg ref={ref} {...props} />);
export const Logo6Icon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <Logo6IconSvg ref={ref} {...props} />);
export const Logo7Icon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <Logo7IconSvg ref={ref} {...props} />);
export const Logo8Icon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <Logo8IconSvg ref={ref} {...props} />);
export const Logo9Icon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <Logo9IconSvg ref={ref} {...props} />);
export const Logo10Icon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <Logo10IconSvg ref={ref} {...props} />);
export const Logo11Icon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <Logo11IconSvg ref={ref} {...props} />);
export const Logo12Icon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <Logo12IconSvg ref={ref} {...props} />);
export const LogoOnHoverIcon= forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => <LogoOnHoverIconSvg ref={ref} {...props} />);
